import { render, staticRenderFns } from "./detailed-message.vue?vue&type=template&id=116edcda&"
import script from "./detailed-message.vue?vue&type=script&lang=js&"
export * from "./detailed-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports